import React from 'react';
import BRAND from '@/brand';

// Spærren vises KUN på hentpost. Står den uden brand-tjek, ville en
// DigitalBox-bruger blive bedt om at flytte til det sted, hun allerede er.
const MAALS_URL = 'https://app.digitalbox.dk';

// En vej forbi, så drift og support stadig kan komme ind: ?bliv i adressen
// gemmes for resten af browsersessionen. Den står her og ikke i en hemmelig
// genvej, fordi en bagdør, ingen kan finde igen, er værre end ingen bagdør.
const NOEGLE = 'hentpost_bliv';

function maaBlive() {
  try {
    if (new URLSearchParams(window.location.search).has('bliv')) {
      sessionStorage.setItem(NOEGLE, '1');
      return true;
    }
    return sessionStorage.getItem(NOEGLE) === '1';
  } catch {
    // Privat vindue eller blokeret lager: så gælder spærren. Hellere det end
    // at en fejl i lageret åbner siden for alle.
    return false;
  }
}

export default function FlyttetSpaerre() {
  if (BRAND.key !== 'hentpost' || maaBlive()) return null;

  return (
    <div
      role="dialog" aria-modal="true" aria-labelledby="flyttet-titel"
      style={{
        position: 'fixed', inset: 0, zIndex: 9999,
        background: 'rgba(15,23,42,.72)', backdropFilter: 'blur(3px)',
        display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24,
      }}
    >
      <div style={{
        maxWidth: 480, width: '100%', background: '#fff', borderRadius: 16,
        padding: '32px 32px 28px',
        boxShadow: '0 20px 60px -20px rgba(0,0,0,.45)',
        fontFamily: 'system-ui, -apple-system, sans-serif',
      }}>
        <h2 id="flyttet-titel" style={{
          margin: 0, fontSize: 24, fontWeight: 700, color: '#0f172a',
          letterSpacing: '-0.02em',
        }}>
          Vi er flyttet til DigitalBox
        </h2>
        <p style={{ margin: '14px 0 0', fontSize: 16, lineHeight: 1.55, color: '#334155' }}>
          Fremover skal du logge ind på <strong>app.digitalbox.dk</strong>.
        </p>
        <p style={{ margin: '12px 0 0', fontSize: 15, lineHeight: 1.55, color: '#475569' }}>
          Din bruger og dine selskaber burde være flyttet med. Kan du ikke logge ind,
          så kontakt os — så hjælper vi dig videre.
        </p>

        <a href={MAALS_URL} style={{
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          height: 48, marginTop: 24, borderRadius: 8, background: '#2563eb',
          color: '#fff', fontSize: 16, fontWeight: 600, textDecoration: 'none',
        }}>
          Gå til DigitalBox →
        </a>

        <p style={{ margin: '16px 0 0', fontSize: 13, color: '#64748b', textAlign: 'center' }}>
          Spørgsmål? Skriv til{' '}
          <a href="mailto:info@digitalbox.dk" style={{ color: '#2563eb' }}>info@digitalbox.dk</a>
        </p>
      </div>
    </div>
  );
}
